export default {
  organization: {
    pages: {
      '_admin-manage-product': {
        title: 'Administrar Organización',
        actions: {
          save_changes: 'Guardar Cambios',
          new_contact: 'Nuevo Contacto',
        },
        labels: {
          contact_title: 'Información de Contacto',
        },
        tabs: {
          contacts: 'Contactos',
          address: 'Dirección',
          others: 'Otros',
        },
      },
      'public-profile': {
        title: '',
        actions: {
          contact: 'Contactar',
        },
      },
    },
    entity: {
      name: 'Nombre',
      tax_id: 'Rut',
      contact: {
        name: 'Nombre',
        email: 'Email',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/organization.js